import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import TopupCalculator from './TopupCalculator';

const TopupInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Topup Loan Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Topup Loan Calculator helps you determine the additional loan amount you can avail on your existing loan. It provides a quick and accurate assessment of your topup loan eligibility based on your current loan details and financial status.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Existing Loan Amount</li>
        <li>Existing EMI</li>
        <li>Loan Tenure</li>
        <li>Interest Rate</li>
        <li>Additional Loan Amount</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses a comprehensive approach to determine your topup loan eligibility:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculates your current loan repayment capacity</li>
        <li>Considers your existing loan tenure and EMI</li>
        <li>Factors in your credit score and repayment history</li>
        <li>Applies the bank's topup loan guidelines</li>
        <li>Provides an estimated additional loan amount</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Quick assessment of topup loan eligibility</li>
        <li>Helps plan additional loan amount</li>
        <li>Identifies maximum borrowable amount</li>
        <li>Provides realistic loan expectations</li>
        <li>Assists in financial planning</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your existing loan amount, current EMI, loan tenure, and interest rate to calculate your topup loan eligibility. The calculator will provide an estimated additional loan amount along with a detailed breakdown of the calculation.</p>
    </div>
  );
};

const Topup = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <TopupCalculator/>
        </div>
        <TopupInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default Topup;